
export const TotalCarrito = ({ texto, valor, className}) => {
    
    return (
        <div className={'row ' + className}>
            <div className='col'>
                {texto}
            </div>
            <div className='col text-end'>
                ${valor}
            </div>
        </div>

    )

}